// src/pages/DijitalImzaView.js - PROFESYONEL VERSİYON
import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import {
  Box, Card, CardContent, Typography, Divider, Chip, Button, TextField,
  Tabs, Tab, Stack, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, MenuItem, Alert, CircularProgress, Tooltip, Paper,
  Avatar, Grid, InputAdornment, Fade, Switch, FormControlLabel,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  AvatarGroup, Menu, ListItemIcon, ListItemText
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr, enUS, de } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import { useNotify } from "react-admin";
import { alpha, styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Icons
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import NotesIcon from "@mui/icons-material/Notes";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import DateRangeIcon from "@mui/icons-material/DateRange";
import LanguageIcon from "@mui/icons-material/Language";
import WorkIcon from "@mui/icons-material/Work";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GetAppIcon from "@mui/icons-material/GetApp";
import SendIcon from "@mui/icons-material/Send";
import CreateIcon from "@mui/icons-material/Create";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";
import HistoryIcon from "@mui/icons-material/History";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// ============================================
// PDF.js Worker - KESİN ÇÖZÜM (2.16.105)
// ============================================

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

/* ==================== STYLED COMPONENTS ==================== */
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 48px rgba(0,0,0,0.12)',
  },
}));

const GradientHeader = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  background: `linear-gradient(135deg, #f57c00 0%, #ff9800 100%)`,
  color: 'white',
  borderRadius: 16,
  marginBottom: theme.spacing(3),
}));

const StatusChip = styled(Chip)(({ theme, statuscolor }) => ({
  fontWeight: 600,
  borderRadius: 8,
  backgroundColor: statuscolor === 'warning' ? '#fff3e0' : 
                  statuscolor === 'success' ? '#e8f5e8' :
                  statuscolor === 'error' ? '#ffebee' : 
                  statuscolor === 'info' ? '#e3f2fd' : '#f3e5f5',
  color: statuscolor === 'warning' ? '#ed6c02' :
         statuscolor === 'success' ? '#2e7d32' :
         statuscolor === 'error' ? '#d32f2f' : 
         statuscolor === 'info' ? '#0288d1' : '#9c27b0',
  border: 'none',
}));

const OrangeButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#f57c00',
  color: 'white',
  '&:hover': {
    backgroundColor: '#e65100',
  },
}));

/* ==================== RENK PALETİ ==================== */
const COLORS = {
  primary: "#f57c00",
  secondary: "#ff9800",
  success: "#2e7d32",
  warning: "#ed6c02",
  error: "#d32f2f",
  info: "#0288d1",
  purple: "#9c27b0",
  teal: "#008080",
  orange: "#f57c00",
};


// API URL
const API = "https://api.haymestasarim.com/api"; 
/* ==================== YARDIMCI FONKSİYONLAR ==================== */
function authHeaders() {
  const token = localStorage.getItem("token");
  return {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}

function getUiLang() {
  const v = localStorage.getItem("app_lang") || localStorage.getItem("lang") || "tr";
  return ["en", "de", "tr"].includes(v) ? v : "tr";
}

const getDateFnsLocale = (lang) => {
  switch (lang) {
    case "tr": return tr;
    case "de": return de;
    default: return enUS;
  }
};

const fullName = (user) => {
  return user?.ad_soyad || 
         [user?.ad, user?.soyad].filter(Boolean).join(' ') || 
         user?.email || 
         'İsimsiz Kullanıcı';
};

/* ==================== I18N ==================== */
const I18N = {
  tr: {
    pageTitle: "Dijital Evrak ve İmza",
    pageDesc: "Evraklarınızı dijital ortamda imzalatın, takip edin, arşivleyin.",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    empty: "Henüz evrak bulunmuyor.",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    add: "Ekle",
    send: "Gönder",
    view: "Görüntüle",
    download: "İndir",
    search: "Ara",
    filter: "Filtrele",
    actions: "İşlemler",
    status: "Durum",
    date: "Tarih",
    select_all: "Tümünü Seç",
    deselect_all: "Seçimi Kaldır",
    
    statsTotal: "Toplam Evrak",
    statsPending: "Bekleyen İmza",
    statsSigned: "İmzalanan",
    statsRejected: "Reddedilen",
    statsExpired: "Süresi Dolan",
    
    searchPlaceholder: "Ara: evrak no, başlık, alıcı...",
    statusLabel: "Durum",
    statusAll: "Tümü",
    statusPending: "Bekleyen",
    statusSigned: "İmzalanan",
    statusRejected: "Reddedilen",
    statusExpired: "Süresi Dolan",
    clearFilters: "Filtreleri Temizle",
    
    chipPending: "İmza Bekliyor",
    chipSigned: "İmzalandı",
    chipRejected: "Reddedildi",
    chipExpired: "Süresi Doldu",
    chipSent: "Gönderildi",
    
    btnNewDocument: "Yeni Evrak Gönder",
    btnUpload: "PDF Yükle",
    btnSelectField: "İmza Alanı Seç",
    btnSend: "Gönder",
    btnResend: "Tekrar Gönder",
    btnSign: "İmzala",
    btnReject: "Reddet",
    btnSettings: "Ayarlar",
    btnArchive: "Arşivle",
    btnHistory: "Geçmiş",
    btnAddField: "Alan Ekle",
    btnClear: "Temizle",
    btnZoomIn: "Yakınlaştır",
    btnZoomOut: "Uzaklaştır",
    btnReset: "Sıfırla",
    btnSaveField: "Alanı Kaydet",
    
    notifyUploadSuccess: "PDF başarıyla yüklendi",
    notifyUploadFail: "PDF yüklenemedi",
    notifySendSuccess: "Evrak gönderildi",
    
    newDocumentTitle: "Yeni Evrak Gönder",
    documentTitle: "Evrak Başlığı",
    description: "Açıklama",
    category: "Kategori",
    pdfFile: "PDF Dosyası",
    pdfUploadText: "PDF yüklemek için tıklayın veya sürükleyin",
    pdfUploadHint: "max 10MB",
    expiryDate: "Son İmza Tarihi",
    recipients: "Alıcılar",
    selected_count: "seçili",
    
    pdfPreview: "PDF Önizleme",
    pdfLoadError: "PDF yüklenemedi. Lütfen dosyayı kontrol edin.",
    selectSignatureField: "İmza Alanını Seçin",
    signatureFieldHint: "PDF üzerinde imza atılacak alanı sürükleyip bırakın",
    fieldTypes: {
      signature: "İmza",
    },
    dragToMove: "Sürükleyerek taşıyın",
    
    tableDocNo: "Evrak No",
    tableTitle: "Başlık",
    tableRecipient: "Alıcı",
    tableSendDate: "Gönderim Tarihi",
    tableExpiryDate: "Son Tarih",
    tableStatus: "Durum",
    tableActions: "İşlemler",
    
    detailDocument: "Evrak Detayı",
    detailRecipients: "Alıcılar",
    
    settingsTitle: "Dijital İmza Ayarları",
    settingsDesc: "İmza modülü ayarlarını yapılandırın.",
    generalSettings: "Genel Ayarlar",
    moduleEnabled: "Modül Aktif",
    emailNotification: "E-posta Bildirimi",
    expiryDays: "Varsayılan Süre (Gün)",
    maxFileSize: "Max Dosya Boyutu (MB)",
    signatureSettings: "İmza Ayarları",
    signatureColor: "İmza Rengi",
    signatureSize: "İmza Boyutu",
    requireName: "İmza ile birlikte ad soyad zorunlu",
    
    warnNoField: "Lütfen imza alanı seçin",
    warnNoRecipient: "Lütfen en az bir alıcı seçin",
    warnNoFile: "Lütfen PDF dosyası yükleyin",
    
    loading_users: "Kullanıcılar yükleniyor...",
    no_users_found: "Kullanıcı bulunamadı",
    view_pdf: "PDF'i Görüntüle",
  },
  
  en: {
    pageTitle: "Digital Document & Signature",
    pageDesc: "Send documents for digital signature, track and archive.",
    refresh: "Refresh",
    loading: "Loading...",
    empty: "No documents found.",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    send: "Send",
    view: "View",
    download: "Download",
    search: "Search",
    filter: "Filter",
    actions: "Actions",
    status: "Status",
    date: "Date",
    select_all: "Select All",
    deselect_all: "Deselect All",
    
    statsTotal: "Total Documents",
    statsPending: "Pending",
    statsSigned: "Signed",
    statsRejected: "Rejected",
    statsExpired: "Expired",
    
    searchPlaceholder: "Search: document no, title, recipient...",
    statusLabel: "Status",
    statusAll: "All",
    statusPending: "Pending",
    statusSigned: "Signed",
    statusRejected: "Rejected",
    statusExpired: "Expired",
    clearFilters: "Clear Filters",
    
    chipPending: "Pending",
    chipSigned: "Signed",
    chipRejected: "Rejected",
    chipExpired: "Expired",
    chipSent: "Sent",
    
    btnNewDocument: "New Document",
    btnUpload: "Upload PDF",
    btnSelectField: "Select Field",
    btnSend: "Send",
    btnResend: "Resend",
    btnSign: "Sign",
    btnReject: "Reject",
    btnSettings: "Settings",
    btnArchive: "Archive",
    btnHistory: "History",
    btnAddField: "Add Field",
    btnClear: "Clear",
    btnZoomIn: "Zoom In",
    btnZoomOut: "Zoom Out",
    btnReset: "Reset",
    btnSaveField: "Save Field",
    
    notifyUploadSuccess: "PDF uploaded successfully",
    notifyUploadFail: "PDF upload failed",
    notifySendSuccess: "Document sent",
    
    newDocumentTitle: "Send New Document",
    documentTitle: "Document Title",
    description: "Description",
    category: "Category",
    pdfFile: "PDF File",
    pdfUploadText: "Click or drag to upload PDF",
    pdfUploadHint: "max 10MB",
    expiryDate: "Expiry Date",
    recipients: "Recipients",
    selected_count: "selected",
    
    pdfPreview: "PDF Preview",
    pdfLoadError: "Failed to load PDF. Please check the file.",
    selectSignatureField: "Select Signature Field",
    signatureFieldHint: "Drag and drop on the PDF to place signature field",
    fieldTypes: {
      signature: "Signature",
    },
    dragToMove: "Drag to move",
    
    tableDocNo: "Doc No",
    tableTitle: "Title",
    tableRecipient: "Recipient",
    tableSendDate: "Send Date",
    tableExpiryDate: "Expiry Date",
    tableStatus: "Status",
    tableActions: "Actions",
    
    detailDocument: "Document Details",
    detailRecipients: "Recipients",
    
    settingsTitle: "Digital Signature Settings",
    settingsDesc: "Configure signature module settings.",
    generalSettings: "General Settings",
    moduleEnabled: "Module Enabled",
    emailNotification: "Email Notification",
    expiryDays: "Default Expiry (Days)",
    maxFileSize: "Max File Size (MB)",
    signatureSettings: "Signature Settings",
    signatureColor: "Signature Color",
    signatureSize: "Signature Size",
    requireName: "Require name with signature",
    
    warnNoField: "Please select a signature field",
    warnNoRecipient: "Please select at least one recipient",
    warnNoFile: "Please upload a PDF file",
    
    loading_users: "Loading users...",
    no_users_found: "No users found",
    view_pdf: "View PDF",
  },
  
  de: {
    pageTitle: "Digitale Dokumente & Signatur",
    pageDesc: "Dokumente digital unterschreiben lassen, verfolgen und archivieren.",
    refresh: "Aktualisieren",
    loading: "Laden...",
    empty: "Keine Dokumente gefunden.",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    add: "Hinzufügen",
    send: "Senden",
    view: "Ansehen",
    download: "Herunterladen",
    search: "Suchen",
    filter: "Filter",
    actions: "Aktionen",
    status: "Status",
    date: "Datum",
    select_all: "Alle auswählen",
    deselect_all: "Auswahl aufheben",
    
    statsTotal: "Dokumente Gesamt",
    statsPending: "Ausstehend",
    statsSigned: "Unterschrieben",
    statsRejected: "Abgelehnt",
    statsExpired: "Abgelaufen",
    
    searchPlaceholder: "Suche: Dokument-Nr., Titel, Empfänger...",
    statusLabel: "Status",
    statusAll: "Alle",
    statusPending: "Ausstehend",
    statusSigned: "Unterschrieben",
    statusRejected: "Abgelehnt",
    statusExpired: "Abgelaufen",
    clearFilters: "Filter löschen",
    
    chipPending: "Ausstehend",
    chipSigned: "Unterschrieben",
    chipRejected: "Abgelehnt",
    chipExpired: "Abgelaufen",
    chipSent: "Gesendet",
    
    btnNewDocument: "Neues Dokument",
    btnUpload: "PDF Hochladen",
    btnSelectField: "Feld Auswählen",
    btnSend: "Senden",
    btnResend: "Erneut Senden",
    btnSign: "Unterschreiben",
    btnReject: "Ablehnen",
    btnSettings: "Einstellungen",
    btnArchive: "Archivieren",
    btnHistory: "Verlauf",
    btnAddField: "Feld hinzufügen",
    btnClear: "Löschen",
    btnZoomIn: "Vergrößern",
    btnZoomOut: "Verkleinern",
    btnReset: "Zurücksetzen",
    btnSaveField: "Feld speichern",
    
    notifyUploadSuccess: "PDF erfolgreich hochgeladen",
    notifyUploadFail: "PDF konnte nicht geladen werden",
    notifySendSuccess: "Dokument gesendet",
    
    newDocumentTitle: "Neues Dokument Senden",
    documentTitle: "Dokumententitel",
    description: "Beschreibung",
    category: "Kategorie",
    pdfFile: "PDF Datei",
    pdfUploadText: "Klicken oder ziehen Sie eine PDF-Datei",
    pdfUploadHint: "max 10MB",
    expiryDate: "Ablaufdatum",
    recipients: "Empfänger",
    selected_count: "ausgewählt",
    
    pdfPreview: "PDF Vorschau",
    pdfLoadError: "PDF konnte nicht geladen werden. Bitte überprüfen Sie die Datei.",
    selectSignatureField: "Unterschriftsfeld Auswählen",
    signatureFieldHint: "Ziehen Sie das Feld auf die gewünschte Position",
    fieldTypes: {
      signature: "Unterschrift",
    },
    dragToMove: "Ziehen zum Verschieben",
    
    tableDocNo: "Dok.-Nr.",
    tableTitle: "Titel",
    tableRecipient: "Empfänger",
    tableSendDate: "Sendedatum",
    tableExpiryDate: "Ablaufdatum",
    tableStatus: "Status",
    tableActions: "Aktionen",
    
    detailDocument: "Dokumentdetails",
    detailRecipients: "Empfänger",
    
    settingsTitle: "Digitale Signatur Einstellungen",
    settingsDesc: "Konfigurieren Sie die Signatur-Einstellungen.",
    generalSettings: "Allgemein",
    moduleEnabled: "Modul Aktiv",
    emailNotification: "E-Mail Benachrichtigung",
    expiryDays: "Standard Ablauf (Tage)",
    maxFileSize: "Max Dateigröße (MB)",
    signatureSettings: "Signatureinstellungen",
    signatureColor: "Signaturfarbe",
    signatureSize: "Signaturgröße",
    requireName: "Name mit Signatur erforderlich",
    
    warnNoField: "Bitte wählen Sie ein Unterschriftsfeld",
    warnNoRecipient: "Bitte wählen Sie mindestens einen Empfänger",
    warnNoFile: "Bitte laden Sie eine PDF-Datei hoch",
    
    loading_users: "Benutzer werden geladen...",
    no_users_found: "Keine Benutzer gefunden",
    view_pdf: "PDF anzeigen",
  }
};

/* ==================== STATUS META ==================== */
function statusMeta(raw, T) {
  const d = String(raw || "").toLowerCase();
  const map = {
    "pending": { label: T.chipPending, color: "warning", icon: <PendingIcon /> },
    "active": { label: T.chipPending, color: "warning", icon: <PendingIcon /> },
    "signed": { label: T.chipSigned, color: "success", icon: <CheckCircleIcon /> },
    "completed": { label: T.chipSigned, color: "success", icon: <CheckCircleIcon /> },
    "rejected": { label: T.chipRejected, color: "error", icon: <CancelIcon /> },
    "expired": { label: T.chipExpired, color: "error", icon: <EventBusyIcon /> },
    "viewed": { label: "Görüntülendi", color: "info", icon: <VisibilityIcon /> },
  };
  return map[d] || { label: raw, color: "default", icon: null };
}

// ==================== SÜRÜKLENEBİLİR İMZA ALANI - YENİ VERSİYON ====================
const DraggableField = ({ field, onUpdate, onDelete, pageNum, scale, containerRef }) => {
  const fieldRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({ x: field.x, y: field.y });

  useEffect(() => {
    setPosition({ x: field.x, y: field.y });
  }, [field.x, field.y]);

  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const rect = fieldRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
    
    setIsDragging(true);
  };

  const handleMouseMove = useCallback((e) => {
    if (!isDragging || !containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    
    // Yeni pozisyonu hesapla (scale faktörünü hesaba kat)
    const newX = (e.clientX - containerRect.left - dragOffset.x) / scale;
    const newY = (e.clientY - containerRect.top - dragOffset.y) / scale;

    // Sınırları kontrol et
    const boundedX = Math.max(0, Math.min(containerRect.width / scale - field.width, newX));
    const boundedY = Math.max(0, Math.min(containerRect.height / scale - field.height, newY));

    setPosition({ x: boundedX, y: boundedY });
  }, [isDragging, dragOffset, field.width, field.height, scale, containerRef]);

  const handleMouseUp = useCallback(() => {
    if (isDragging) {
      setIsDragging(false);
      // Sürükleme bittiğinde güncelle
      onUpdate({
        ...field,
        x: position.x,
        y: position.y
      });
    }
  }, [isDragging, field, position, onUpdate]);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
    }
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  if (field.page !== pageNum) return null;

  return (
    <Box
      ref={fieldRef}
      onMouseDown={handleMouseDown}
      sx={{
        position: 'absolute',
        left: position.x,
        top: position.y,
        width: field.width,
        height: field.height,
        border: `2px solid ${COLORS.primary}`,
        backgroundColor: alpha(COLORS.primary, 0.1),
        borderRadius: 1,
        cursor: isDragging ? 'grabbing' : 'grab',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: isDragging ? 'none' : 'box-shadow 0.2s',
        boxShadow: isDragging ? `0 0 15px ${alpha(COLORS.primary, 0.5)}` : 'none',
        zIndex: isDragging ? 9999 : 10,
        '&:hover': {
          backgroundColor: alpha(COLORS.primary, 0.2),
          borderWidth: '3px',
          '& .delete-icon': {
            display: 'flex',
          },
        },
      }}
    >
      <FingerprintIcon sx={{ color: COLORS.primary, fontSize: 20 }} />
      
      {/* Boyutlandırma tutamacı */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: 16,
          height: 16,
          cursor: 'se-resize',
          backgroundColor: COLORS.primary,
          borderRadius: '0 0 4px 0',
          display: 'none',
          '&:hover': {
            backgroundColor: COLORS.secondary,
          },
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
          // Boyutlandırma mantığı eklenebilir
        }}
      />
      
      <IconButton
        size="small"
        className="delete-icon"
        sx={{
          position: 'absolute',
          top: -20,
          right: -20,
          display: 'none',
          bgcolor: COLORS.error,
          color: 'white',
          padding: '4px',
          '&:hover': { bgcolor: '#b71c1c' },
          zIndex: 20,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onDelete(field.id);
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      
      {/* Pozisyon göstergesi (opsiyonel) */}
      {isDragging && (
        <Box
          sx={{
            position: 'absolute',
            top: -25,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '2px 8px',
            borderRadius: 4,
            fontSize: '11px',
            whiteSpace: 'nowrap',
            zIndex: 10000,
          }}
        >
          {Math.round(position.x)}x, {Math.round(position.y)}y
        </Box>
      )}
    </Box>
  );
};

/* ==================== PDF ÖNİZLEME DİALOG ==================== */
function PdfPreviewDialog({ open, onClose, pdfFile, fields, onFieldAdd, onFieldUpdate, onFieldDelete, T }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [isAddingField, setIsAddingField] = useState(false);
  const [pdfError, setPdfError] = useState(false);
  const containerRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (pdfFile) {
      try {
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        const url = URL.createObjectURL(pdfFile);
        console.log("PDF URL oluşturuldu:", url);
        setPdfUrl(url);
        setPdfError(false);
        
        return () => {
          console.log("PDF URL temizleniyor:", url);
          URL.revokeObjectURL(url);
        };
      } catch (error) {
        console.error("PDF URL oluşturma hatası:", error);
        setPdfError(true);
      }
    }
  }, [pdfFile]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log("PDF başarıyla yüklendi, sayfa sayısı:", numPages);
    setNumPages(numPages);
    setPdfError(false);
  };

  const onDocumentLoadError = (error) => {
    console.error("PDF yükleme hatası:", error);
    setPdfError(true);
  };

  const handlePageClick = (e) => {
    if (!isAddingField || !containerRef.current) return;

    const container = containerRef.current.getBoundingClientRect();
    const x = e.clientX - container.left;
    const y = e.clientY - container.top;

const newField = {
  id: Date.now(),
  page: pageNumber,
  x: x,  // 👈 Hiç sınır yok!
  y: y,  // 👈 İstediğin her yere koyabilirsin
  width: 150,
  height: 50,
  type: 'signature'
};

    onFieldAdd(newField);
    setIsAddingField(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <PictureAsPdfIcon sx={{ color: COLORS.primary }} />
            <Typography variant="h6">{T.pdfPreview}</Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Tooltip title={T.btnZoomOut}>
              <IconButton onClick={() => setScale(s => Math.max(0.5, s - 0.1))}>
                <ZoomOutIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={T.btnZoomIn}>
              <IconButton onClick={() => setScale(s => Math.min(2, s + 0.1))}>
                <ZoomInIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={T.btnReset}>
              <IconButton onClick={() => setScale(1)}>
                <RestartAltIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} md={9}>
            <Paper
              variant="outlined"
              ref={containerRef}
              onClick={handlePageClick}
              sx={{
height: 'calc(100vh - 150px)',             bgcolor: '#f5f5f5',
                position: 'relative',
                overflow: 'auto',
                cursor: isAddingField ? 'crosshair' : 'default',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {pdfError ? (
                <Box textAlign="center">
                  <WarningIcon sx={{ fontSize: 48, color: COLORS.error, mb: 2 }} />
                  <Typography color="error">{T.pdfLoadError}</Typography>
                </Box>
              ) : pdfUrl ? (
<Document
  file={pdfUrl}
  onLoadSuccess={onDocumentLoadSuccess}
  onLoadError={onDocumentLoadError}
  loading={
    <Box textAlign="center">
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>{T.loading}</Typography>
    </Box>
  }
>
  <Page
    pageNumber={pageNumber}
    scale={scale}
    renderTextLayer={true}
    renderAnnotationLayer={true}
  />
</Document>


              ) : (
                <Box textAlign="center">
                  <PictureAsPdfIcon sx={{ fontSize: 48, color: COLORS.primary, opacity: 0.5 }} />
                  <Typography color="text.secondary">{T.pdfUploadText}</Typography>
                </Box>
              )}
              
              {fields.map((field) => (
                <DraggableField
                  key={field.id}
                  field={field}
                  onUpdate={onFieldUpdate}
                  onDelete={onFieldDelete}
                  pageNum={pageNumber}
                  scale={scale}
                  containerRef={containerRef}
                />
              ))}
              
              {isAddingField && !pdfError && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: alpha(COLORS.primary, 0.2),
                    border: `2px dashed ${COLORS.primary}`,
                    borderRadius: 1,
                    p: 2,
                    color: COLORS.primary,
                    fontWeight: 600,
                  }}
                >
                  {T.selectSignatureField}
                </Box>
              )}
            </Paper>
            
            {!pdfError && pdfUrl && (
              <Stack direction="row" spacing={2} sx={{ mt: 2 }} justifyContent="center">
                <Button
                  variant={isAddingField ? "contained" : "outlined"}
                  color={isAddingField ? "success" : "primary"}
                  onClick={() => setIsAddingField(!isAddingField)}
                  startIcon={<AddIcon />}
                >
                  {isAddingField ? T.btnSaveField : T.btnAddField}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setPageNumber(p => Math.max(1, p - 1))}
                  disabled={pageNumber <= 1}
                >
                  {T.btnZoomOut}
                </Button>
                <Typography sx={{ alignSelf: 'center' }}>
                  {pageNumber} / {numPages || '?'}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => setPageNumber(p => Math.min(numPages || p, p + 1))}
                  disabled={pageNumber >= (numPages || 1)}
                >
                  {T.btnZoomIn}
                </Button>
              </Stack>
            )}
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle2" gutterBottom sx={{ color: COLORS.primary, fontWeight: 600 }}>
              {T.selectSignatureField}
            </Typography>
            <Typography variant="caption" color="text.secondary" paragraph>
              {T.signatureFieldHint}
            </Typography>
            
            {fields.length > 0 ? (
              <Stack spacing={1}>
                {fields.map((field) => (
                  <Paper key={field.id} variant="outlined" sx={{ p: 1 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Stack direction="row" spacing={1} alignItems="center">
                        <DragIndicatorIcon sx={{ color: COLORS.primary, fontSize: 18, cursor: 'grab' }} />
                        <Box>
                          <Typography variant="caption" fontWeight={600}>
                            {T.fieldTypes.signature}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" display="block">
                            Sayfa {field.page}
                          </Typography>
                        </Box>
                      </Stack>
                      <IconButton size="small" color="error" onClick={() => onFieldDelete(field.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            ) : (
              <Alert severity="info">
                {T.signatureFieldHint}
              </Alert>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>{T.cancel}</Button>
        <OrangeButton variant="contained" onClick={onClose}>
          {T.save}
        </OrangeButton>
      </DialogActions>
    </Dialog>
  );
}

/* ==================== ALICI SEÇİM BİLEŞENİ ==================== */
const RecipientSelector = ({ users, selectedIds, onChange, T }) => {
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setSelectAll(selectedIds.length === users.length && users.length > 0);
  }, [selectedIds, users]);

  const handleSelectAll = () => {
    if (selectAll) {
      onChange([]);
    } else {
      onChange(users.map(u => u.id));
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" sx={{ color: COLORS.primary, fontWeight: 700 }}>
          {T.recipients}
        </Typography>
        {users.length > 0 && (
          <Button size="small" onClick={handleSelectAll}>
            {selectAll ? T.deselect_all : T.select_all}
          </Button>
        )}
      </Stack>
      
      {users.length === 0 ? (
        <Alert severity="info">{T.no_users_found}</Alert>
      ) : (
        <Paper variant="outlined" sx={{ maxHeight: 300, overflow: 'auto' }}>
          {users.map((user) => (
            <MenuItem
              key={user.id}
              onClick={() => {
                const newSelected = selectedIds.includes(user.id)
                  ? selectedIds.filter(x => x !== user.id)
                  : [...selectedIds, user.id];
                onChange(newSelected);
              }}
              sx={{ 
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-child': { borderBottom: 'none' }
              }}
            >
              <Avatar sx={{ width: 32, height: 32, bgcolor: selectedIds.includes(user.id) ? COLORS.success : COLORS.primary, mr: 1 }}>
                {fullName(user).charAt(0)}
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" fontWeight={600}>
                  {fullName(user)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {user.email || 'E-posta yok'}
                </Typography>
              </Box>
              {selectedIds.includes(user.id) && (
                <CheckCircleIcon sx={{ color: COLORS.success, ml: 1 }} fontSize="small" />
              )}
            </MenuItem>
          ))}
        </Paper>
      )}
      {selectedIds.length > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {selectedIds.length} {T.selected_count}
        </Typography>
      )}
    </Paper>
  );
};

/* ==================== ANA BİLEŞEN ==================== */
export default function DijitalImzaView() {
  const notify = useNotify();
  const navigate = useNavigate();
  
  const uiLang = useMemo(() => getUiLang(), []);
  const T = I18N[uiLang] || I18N.tr;
  
  // State'ler
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
const [sending, setSending] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  
  // Filtreler
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  
  // Modal'lar
  const [newDocumentOpen, setNewDocumentOpen] = useState(false);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  
  // Yeni evrak state
  const [newDocument, setNewDocument] = useState({
    title: '',
    description: '',
    category: '',
    pdfFile: null,
    expiryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    recipients: [],
    fields: []
  });
  
// Ayarlar state - SINIRSIZ PDF
const [settings, setSettings] = useState({
  moduleEnabled: true,
  emailNotification: true,
  expiryDays: 7,
  maxFileSize: 1000,        
  signatureColor: '#000000',
  signatureSize: 100,
  requireName: true,
});
  
  // Kullanıcı listesi
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  
  // Kategori listesi
  const categories = [
    { value: 'contract', label: uiLang === 'tr' ? 'Sözleşme' : uiLang === 'de' ? 'Vertrag' : 'Contract' },
    { value: 'policy', label: uiLang === 'tr' ? 'Poliçe' : uiLang === 'de' ? 'Police' : 'Policy' },
    { value: 'form', label: uiLang === 'tr' ? 'Form' : uiLang === 'de' ? 'Formular' : 'Form' },
    { value: 'agreement', label: uiLang === 'tr' ? 'Anlaşma' : uiLang === 'de' ? 'Vereinbarung' : 'Agreement' },
    { value: 'other', label: uiLang === 'tr' ? 'Diğer' : uiLang === 'de' ? 'Andere' : 'Other' },
  ];
  
   // Kullanıcıları getir
  const fetchUsers = async () => {
  setUsersLoading(true);

  try {
    const token = localStorage.getItem("token");

    const res = await fetch(`${API}/kullanicilar`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    const json = await res.json();
    setUsers(json.data || []);

  } catch (err) {
    console.error("Users load error:", err);
  }

  setUsersLoading(false);
};
 
// İstatistikler

const stats = useMemo(() => {
  return {
    total: documents.length,
    pending: documents.filter(d => d.document_status === 'pending' || d.document_status === 'active').length,
    signed: documents.filter(d => d.document_status === 'signed' || d.document_status === 'completed').length,
    rejected: documents.filter(d => d.document_status === 'rejected').length,
    expired: documents.filter(d => d.document_status === 'expired').length,
  };
}, [documents]);

// Filtrelenmiş evraklar - document_status kullan
const filteredDocuments = useMemo(() => {
  let filtered = documents;
  
  if (searchQuery) {
    filtered = filtered.filter(doc => 
      doc.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      doc.description?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }
  
  if (statusFilter !== 'all') {
    filtered = filtered.filter(doc => doc.document_status === statusFilter);
  }
  
  return filtered;
}, [searchQuery, statusFilter, documents]);


// Veri çekme - GERÇEK API
// Veri çekme - MuhasebeBelgeler'deki gibi düzeltilmiş versiyon
const fetchDocuments = async (silent = false) => {
  try {
    if (!silent) setLoading(true);
    setRefreshing(true);
    
    const token = localStorage.getItem("token");
    const res = await fetch(`${API}/dijitalimza/documents`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (res.ok) {
      const json = await res.json();
      console.log("📥 Gelen veri:", json); // Veriyi görelim
      
      // MuhasebeBelgeler'deki gibi doğrudan json.data'yı kullan
      // HİÇBİR DÖNÜŞÜM YAPMA!
      setDocuments(json.data || []);
    } else {
      console.error("Hata:", res.status);
      setDocuments([]);
      if (!silent) notify("Evraklar yüklenemedi", { type: "error" });
    }
  } catch (error) {
    console.error("❌ Evraklar yüklenemedi:", error);
    setDocuments([]);
    if (!silent) notify("Evraklar yüklenemedi", { type: "error" });
  } finally {
    setLoading(false);
    setRefreshing(false);
  }
};

  useEffect(() => {
    fetchDocuments();
    fetchUsers();
  }, []);

  // PDF yükleme
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    console.log("Dosya seçildi:", file.name, file.type, file.size);
    
    if (file.type !== 'application/pdf') {
      notify('Lütfen geçerli bir PDF dosyası seçin', { type: "error" });
      return;
    }
    
    const maxSize = settings.maxFileSize * 1024 * 1024;
    if (file.size > maxSize) {
      notify(`Dosya boyutu ${settings.maxFileSize}MB'dan büyük olamaz`, { type: "error" });
      return;
    }
    
    setNewDocument({ ...newDocument, pdfFile: file });
    notify(T.notifyUploadSuccess, { type: "success" });
    
    setTimeout(() => {
      setPdfPreviewOpen(true);
    }, 100);
  };

  // İmza alanı ekle
  const handleFieldAdd = (field) => {
    setNewDocument({
      ...newDocument,
      fields: [...newDocument.fields, field]
    });
  };

  // İmza alanı güncelle
  const handleFieldUpdate = (updatedField) => {
    setNewDocument({
      ...newDocument,
      fields: newDocument.fields.map(f => f.id === updatedField.id ? updatedField : f)
    });
  };

  // İmza alanı sil
  const handleFieldDelete = (fieldId) => {
    setNewDocument({
      ...newDocument,
      fields: newDocument.fields.filter(f => f.id !== fieldId)
    });
  };

// Evrak gönder - GERÇEK API
const sendDocument = async () => {
  if (!newDocument.pdfFile) {
    notify(T.warnNoFile, { type: "warning" });
    return;
  }
  if (newDocument.fields.length === 0) {
    notify(T.warnNoField, { type: "warning" });
    return;
  }
  if (newDocument.recipients.length === 0) {
    notify(T.warnNoRecipient, { type: "warning" });
    return;
  }

  setSending(true);

  try {
    const token = localStorage.getItem("token");

    // PDF yükleme
    const formData = new FormData();
    formData.append("file", newDocument.pdfFile);

    const uploadRes = await fetch(`${API}/upload`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    if (!uploadRes.ok) throw new Error("PDF yüklenemedi");

    const uploadData = await uploadRes.json();
    const pdfUrl = uploadData.url;

    const docRes = await fetch(`${API}/dijitalimza/documents`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        title: newDocument.title?.trim() || newDocument.pdfFile?.name || "İmzalı Evrak",
        description: newDocument.description || "",
        category: newDocument.category || "other",
        original_pdf_url: pdfUrl,
        expiry_date: newDocument.expiryDate.toISOString().split("T")[0],
        recipients: newDocument.recipients,
        fields: newDocument.fields.map(f => ({
          page_number: f.page,
          x: f.x,
          y: f.y,
          width: f.width,
          height: f.height,
          field_type: f.type || "signature"
        }))
      })
    });

    if (!docRes.ok) throw new Error("Evrak oluşturulamadı");

    notify(T.notifySendSuccess, { type: "success" });
    setNewDocumentOpen(false);
    resetNewDocument();
    fetchDocuments(true);

  } catch (error) {
    console.error("Gönderme hatası:", error);
    notify(T.notifyUploadFail, { type: "error" });

  } finally {
    setSending(false);
  }
};
  // Filtreleri temizle
  const clearFilters = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setDateRange({ start: "", end: "" });
  };
 // pdf indirme
const handleDownload = (doc) => {
  if (!doc?.original_pdf_url) {
    notify("PDF bulunamadı", { type: "warning" });
    return;
  }

  const url = doc.original_pdf_url.startsWith("http")
    ? doc.original_pdf_url
    : `https://api.haymestasarim.com${doc.original_pdf_url}`;

  window.open(url, "_blank");
};



  // Menü işlemleri
  const handleMenuClick = (event, doc) => {
    setAnchorEl(event.currentTarget);
    setSelectedDoc(doc);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedDoc(null);
  };

  const handleViewDocument = () => {
    setDetailOpen(true);
    handleMenuClose();
  };

  const handleResend = () => {
    notify('Evrak tekrar gönderildi', { type: "success" });
    handleMenuClose();
  };

  const handleArchive = () => {
    notify('Evrak arşivlendi', { type: "success" });
    handleMenuClose();
  };

  // Ayarları kaydet
  const saveSettings = () => {
    notify(T.notifyUploadSuccess, { type: "success" });
    setSettingsOpen(false);
  };

  const resetNewDocument = () => {
    setNewDocument({
      title: '',
      description: '',
      category: '',
      pdfFile: null,
      expiryDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      recipients: [],
      fields: []
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={getDateFnsLocale(uiLang)}>
      <Box sx={{ width: "100%", px: { xs: 1, sm: 2, md: 3 }, pb: 6 }}>
        
        {/* HEADER */}
        <GradientHeader elevation={0}>
          <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems="center" spacing={2}>
            <Box>
              <Typography variant="h4" fontWeight={900} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <DescriptionIcon fontSize="large" /> 
                {T.pageTitle}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
                {T.pageDesc}
              </Typography>
            </Box>
            
            <Stack direction="row" spacing={1}>
              <Tooltip title={T.refresh}>
                <IconButton 
                  onClick={() => fetchDocuments()} 
                  sx={{ 
                    color: "white", 
                    bgcolor: "rgba(255,255,255,0.1)",
                    '&:hover': { bgcolor: "rgba(255,255,255,0.2)" }
                  }}
                >
                  {refreshing ? <CircularProgress size={24} color="inherit" /> : <RefreshIcon />}
                </IconButton>
              </Tooltip>
              
              <Button
                variant="contained"
                startIcon={<SettingsIcon />}
                onClick={() => setSettingsOpen(true)}
                sx={{
                  bgcolor: "white",
                  color: COLORS.primary,
                  fontWeight: 700,
                  '&:hover': { bgcolor: "rgba(255,255,255,0.9)" }
                }}
              >
                {T.btnSettings}
              </Button>
            </Stack>
          </Stack>
        </GradientHeader>

        {/* STATS CARDS */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              sm: "repeat(3, 1fr)",
              md: "repeat(5, 1fr)",
            },
            gap: 2,
            mb: 3,
          }}
        >
          <StatCard label={T.statsTotal} value={stats.total} icon={<DescriptionIcon />} color={COLORS.primary} />
          <StatCard label={T.statsPending} value={stats.pending} icon={<PendingIcon />} color={COLORS.warning} />
          <StatCard label={T.statsSigned} value={stats.signed} icon={<VerifiedIcon />} color={COLORS.success} />
          <StatCard label={T.statsRejected} value={stats.rejected} icon={<CancelIcon />} color={COLORS.error} />
          <StatCard label={T.statsExpired} value={stats.expired} icon={<EventBusyIcon />} color={COLORS.secondary} />
        </Box>

        {/* ANA İÇERİK */}
        <StyledCard>
          {/* Toolbar */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center" justifyContent="space-between">
              <Stack direction="row" spacing={1}>
                <OrangeButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setNewDocumentOpen(true)}
                >
                  {T.btnNewDocument}
                </OrangeButton>
              </Stack>
              
              <Stack direction="row" spacing={1} sx={{ width: { xs: '100%', md: 'auto' } }}>
                <TextField
                  size="small"
                  placeholder={T.searchPlaceholder}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: { xs: '100%', md: 300 } }}
                />
                <Button variant="outlined" onClick={clearFilters}>
                  {T.clearFilters}
                </Button>
              </Stack>
            </Stack>
          </Box>

          {/* Filtreler */}
          <Fade in={true}>
            <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                <TextField
                  select
                  size="small"
                  label={T.statusLabel}
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  sx={{ minWidth: 200 }}
                >
                  <MenuItem value="all">{T.statusAll}</MenuItem>
                  <MenuItem value="pending">{T.statusPending}</MenuItem>
                  <MenuItem value="signed">{T.statusSigned}</MenuItem>
                  <MenuItem value="rejected">{T.statusRejected}</MenuItem>
                  <MenuItem value="expired">{T.statusExpired}</MenuItem>
                </TextField>
                
                <TextField
                  type="date"
                  size="small"
                  label={T.startDate}
                  value={dateRange.start}
                  onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
                
                <TextField
                  type="date"
                  size="small"
                  label={T.endDate}
                  value={dateRange.end}
                  onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                />
              </Stack>
            </Box>
          </Fade>

          {/* Tablo */}
          <CardContent>
            {loading ? (
              <Box sx={{ py: 8, textAlign: "center" }}>
                <CircularProgress />
                <Typography sx={{ mt: 2 }} color="text.secondary">
                  {T.loading}
                </Typography>
              </Box>
            ) : filteredDocuments.length === 0 ? (
              <Paper sx={{ p: 4, textAlign: "center", bgcolor: 'grey.50' }}>
                <DescriptionIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
                <Typography color="text.secondary">{T.empty}</Typography>
              </Paper>
            ) : (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.50' }}>
                      <TableCell>{T.tableDocNo}</TableCell>
                      <TableCell>{T.tableTitle}</TableCell>
                      <TableCell>{T.tableRecipient}</TableCell>
                      <TableCell>{T.tableSendDate}</TableCell>
                      <TableCell>{T.tableExpiryDate}</TableCell>
                      <TableCell>{T.tableStatus}</TableCell>
                      <TableCell align="right">{T.tableActions}</TableCell>
                    </TableRow>
                  </TableHead>


<TableBody>
  {filteredDocuments && filteredDocuments.length > 0 ? (
    filteredDocuments.map((doc) => {
      // Güvenli erişim
      const safeDoc = doc || {};
      const meta = statusMeta(safeDoc.document_status || 'pending', T);
      
      // Alıcıları güvenli şekilde al
      const recipients = safeDoc.recipients || [];
      
      return (
        <TableRow key={safeDoc.id || Math.random()} hover>
          <TableCell>
            <Typography variant="body2" fontWeight={600}>
              {safeDoc.id ? `#${safeDoc.id.toString().slice(-6)}` : '-'}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2" fontWeight={600}>
              {safeDoc.title || '-'}
            </Typography>
          </TableCell>
          <TableCell>
            <AvatarGroup max={3} sx={{ justifyContent: 'flex-start' }}>
              {recipients.map((r, index) => (
                <Tooltip key={index} title={r?.name || r?.ad || ''}>
                
  <Avatar sx={{ 
  width: 32, 
  height: 32, 
  bgcolor: (r?.status === 'signed' || r?.recipient_status === 'signed') ? COLORS.success : COLORS.warning 
}}>
  {(r?.name || r?.ad || '?').charAt(0)}
</Avatar>

                </Tooltip>
              ))}
            </AvatarGroup>
          </TableCell>
          <TableCell>
            <Typography variant="body2">
              {safeDoc.created_at ? new Date(safeDoc.created_at).toLocaleDateString() : '-'}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body2">
              {safeDoc.expiry_date ? new Date(safeDoc.expiry_date).toLocaleDateString() : '-'}
            </Typography>
          </TableCell>
          <TableCell>
            <StatusChip
              size="small"
              icon={meta.icon}
              label={meta.label}
              statuscolor={meta.color}
            />
          </TableCell>

<TableCell align="right">
  {/* İmzalı PDF varsa göster */}
  {safeDoc.signed_pdf_url && (
    <IconButton
      size="small"
      color="success"
      href={safeDoc.signed_pdf_url}
      target="_blank"
      title="İmzalı PDF"
    >
      <VerifiedIcon fontSize="small" />
    </IconButton>
  )}
  
  {/* Normal PDF indir */}
  <IconButton
    size="small"
    onClick={() => handleDownload(safeDoc)}
    title="PDF İndir"
  >
    <GetAppIcon fontSize="small" />
  </IconButton>

  <IconButton
    size="small"
    onClick={() => {
      setSelectedDoc(safeDoc);
      setDetailOpen(true);
    }}
    title="Detay"
  >
    <VisibilityIcon fontSize="small" />
  </IconButton>

  <IconButton
    size="small"
    onClick={(e) => handleMenuClick(e, safeDoc)}
    title="İşlemler"
  >
    <MoreVertIcon fontSize="small" />
  </IconButton>
</TableCell>


        </TableRow>
      );
    })
  ) : (
    <TableRow>
      <TableCell colSpan={7} align="center">
        <Typography color="text.secondary">{T.empty}</Typography>
      </TableCell>
    </TableRow>
  )}
</TableBody>


                </Table>
              </TableContainer>
            )}
          </CardContent>
        </StyledCard>

        {/* YENİ EVRAK MODAL */}
        <Dialog 
          open={newDocumentOpen} 
          onClose={() => { setNewDocumentOpen(false); resetNewDocument(); }} 
          maxWidth="md" 
          fullWidth
        >
          <DialogTitle>
            <Stack direction="row" alignItems="center" spacing={1}>
              <DescriptionIcon sx={{ color: COLORS.primary }} />
              <Typography variant="h6">{T.newDocumentTitle}</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent dividers>
            <Stack spacing={3}>
              {/* Temel Bilgiler */}
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS.primary, fontWeight: 700, mb: 2 }}>
                  {T.generalSettings}
                </Typography>
                
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label={T.documentTitle}
                      value={newDocument.title}
                      onChange={(e) => setNewDocument({ ...newDocument, title: e.target.value })}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label={T.category}
                      value={newDocument.category}
                      onChange={(e) => setNewDocument({ ...newDocument, category: e.target.value })}
                    >
                      {categories.map((cat) => (
                        <MenuItem key={cat.value} value={cat.value}>
                          {cat.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label={T.expiryDate}
                      value={newDocument.expiryDate}
                      onChange={(date) => setNewDocument({ ...newDocument, expiryDate: date })}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label={T.description}
                      value={newDocument.description}
                      onChange={(e) => setNewDocument({ ...newDocument, description: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Paper>

              {/* PDF Yükleme */}
              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS.primary, fontWeight: 700, mb: 2 }}>
                  {T.pdfFile}
                </Typography>
                
                <Box
                  sx={{
                    border: `2px dashed ${newDocument.pdfFile ? COLORS.success : COLORS.primary}`,
                    borderRadius: 2,
                    p: 4,
                    textAlign: 'center',
                    bgcolor: alpha(COLORS.primary, 0.02),
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': {
                      bgcolor: alpha(COLORS.primary, 0.05),
                      borderColor: COLORS.secondary,
                    }
                  }}
                  onClick={() => document.getElementById('pdf-upload').click()}
                >
                  <input
                    type="file"
                    id="pdf-upload"
                    accept=".pdf"
                    style={{ display: 'none' }}
                    onChange={handleFileUpload}
                  />
                  
                  {newDocument.pdfFile ? (
                    <>
                      <PictureAsPdfIcon sx={{ fontSize: 48, color: COLORS.success }} />
                      <Typography variant="body1" sx={{ mt: 1, fontWeight: 600 }}>
                        {newDocument.pdfFile.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {(newDocument.pdfFile.size / 1024 / 1024).toFixed(2)} MB
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ mt: 2 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPdfPreviewOpen(true);
                        }}
                      >
                        {T.btnSelectField}
                      </Button>
                    </>
                  ) : (
                    <>
                      <CloudUploadIcon sx={{ fontSize: 48, color: COLORS.primary }} />
                      <Typography variant="body1" sx={{ mt: 1, fontWeight: 600 }}>
                        {T.pdfUploadText}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {T.pdfUploadHint}
                      </Typography>
                    </>
                  )}
                </Box>
              </Paper>

              {/* İmza Alanları */}
              {newDocument.fields.length > 0 && (
                <Paper variant="outlined" sx={{ p: 3 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ color: COLORS.primary, fontWeight: 700 }}>
                      {T.selectSignatureField} ({newDocument.fields.length})
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<EditIcon />}
                      onClick={() => setPdfPreviewOpen(true)}
                      sx={{ color: COLORS.primary, borderColor: COLORS.primary }}
                    >
                      {T.btnSelectField}
                    </Button>
                  </Stack>
                  
                  <Box sx={{ maxHeight: 200, overflow: 'auto' }}>
                    {newDocument.fields.map((field, index) => (
                      <Paper key={field.id} variant="outlined" sx={{ p: 1.5, mb: 1, bgcolor: alpha(COLORS.primary, 0.04) }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Stack direction="row" spacing={1.5} alignItems="center">
                            <FingerprintIcon fontSize="small" sx={{ color: COLORS.primary }} />
                            <Box>
                              <Typography variant="body2" fontWeight={600}>
                                {T.fieldTypes.signature}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                Sayfa {field.page}
                              </Typography>
                            </Box>
                          </Stack>
                          <IconButton size="small" color="error" onClick={() => handleFieldDelete(field.id)}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </Paper>
                    ))}
                  </Box>
                </Paper>
              )}

              {/* Alıcılar */}
              {usersLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                  <CircularProgress size={24} />
                  <Typography sx={{ ml: 1 }}>{T.loading_users}</Typography>
                </Box>
              ) : (
                <RecipientSelector
                  users={users}
                  selectedIds={newDocument.recipients}
                  onChange={(ids) => setNewDocument({ ...newDocument, recipients: ids })}
                  T={T}
                />
              )}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={() => { setNewDocumentOpen(false); resetNewDocument(); }} size="large">
              {T.cancel}
            </Button>
            <OrangeButton 
              variant="contained" 
              onClick={sendDocument}
              startIcon={<SendIcon />}
              size="large"
              sx={{ px: 4 }}
            >
              {T.btnSend}
            </OrangeButton>
          </DialogActions>
        </Dialog>

        {/* PDF ALAN SEÇ MODAL */}
        <PdfPreviewDialog
          open={pdfPreviewOpen}
          onClose={() => setPdfPreviewOpen(false)}
          pdfFile={newDocument.pdfFile}
          fields={newDocument.fields}
          onFieldAdd={handleFieldAdd}
          onFieldUpdate={handleFieldUpdate}
          onFieldDelete={handleFieldDelete}
          T={T}
        />

        {/* EVRAK DETAY MODAL */}
        <Dialog 
          open={detailOpen} 
          onClose={() => setDetailOpen(false)} 
          maxWidth="md" 
          fullWidth
        >
          <DialogTitle>
            <Stack direction="row" alignItems="center" spacing={1}>
              <DescriptionIcon sx={{ color: COLORS.primary }} />
              <Typography variant="h6">{T.detailDocument}</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent dividers>

           {selectedDoc && (
  <Stack spacing={3}>
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            {T.tableDocNo}
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {selectedDoc.id || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" color="text.secondary">
            {T.tableTitle}
          </Typography>
          <Typography variant="body2">
            {selectedDoc.title || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="caption" color="text.secondary">
            {T.description}
          </Typography>
          <Typography variant="body2">
            {selectedDoc.description || '-'}
          </Typography>
        </Grid>
      </Grid>
    </Paper>

    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom sx={{ color: COLORS.primary, fontWeight: 600 }}>
        {T.detailRecipients}
      </Typography>
      
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Alıcı</TableCell>
              <TableCell>Durum</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(selectedDoc.recipients || []).map((r, index) => {
              const meta = statusMeta(r.status || r.recipient_status || 'pending', T);
              return (
                <TableRow key={index}>
                  <TableCell>{r.name || r.ad || '-'}</TableCell>
                  <TableCell>
                    <StatusChip
                      size="small"
                      icon={meta.icon}
                      label={meta.label}
                      statuscolor={meta.color}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  </Stack>
)}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setDetailOpen(false)}>{T.cancel}</Button>
          </DialogActions>
        </Dialog>

        {/* AYARLAR MODAL */}
        <Dialog 
          open={settingsOpen} 
          onClose={() => setSettingsOpen(false)} 
          maxWidth="md" 
          fullWidth
        >
          <DialogTitle>
            <Stack direction="row" alignItems="center" spacing={1}>
              <SettingsIcon sx={{ color: COLORS.primary }} />
              <Typography variant="h6">{T.settingsTitle}</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent dividers>
            <Stack spacing={3}>
              <Alert severity="info">
                {T.settingsDesc}
              </Alert>

              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS.primary, fontWeight: 700, mb: 2 }}>
                  {T.generalSettings}
                </Typography>
                
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={settings.moduleEnabled}
                          onChange={(e) => setSettings({ ...settings, moduleEnabled: e.target.checked })}
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: COLORS.success,
                            },
                          }}
                        />
                      }
                      label={T.moduleEnabled}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={settings.emailNotification}
                          onChange={(e) => setSettings({ ...settings, emailNotification: e.target.checked })}
                        />
                      }
                      label={T.emailNotification}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label={T.expiryDays}
                      value={settings.expiryDays}
                      onChange={(e) => setSettings({ ...settings, expiryDays: Number(e.target.value) })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label={T.maxFileSize}
                      value={settings.maxFileSize}
                      onChange={(e) => setSettings({ ...settings, maxFileSize: Number(e.target.value) })}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">MB</InputAdornment>,
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ color: COLORS.primary, fontWeight: 700, mb: 2 }}>
                  {T.signatureSettings}
                </Typography>
                
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="color"
                      label={T.signatureColor}
                      value={settings.signatureColor}
                      onChange={(e) => setSettings({ ...settings, signatureColor: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label={T.signatureSize}
                      value={settings.signatureSize}
                      onChange={(e) => setSettings({ ...settings, signatureSize: Number(e.target.value) })}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">px</InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={settings.requireName}
                          onChange={(e) => setSettings({ ...settings, requireName: e.target.checked })}
                        />
                      }
                      label={T.requireName}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={() => setSettingsOpen(false)} size="large">{T.cancel}</Button>
            <OrangeButton 
              variant="contained" 
              onClick={saveSettings}
              startIcon={<SaveIcon />}
              size="large"
              sx={{ px: 4 }}
            >
              {T.save}
            </OrangeButton>
          </DialogActions>
        </Dialog>

        {/* İŞLEM MENÜSÜ */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleViewDocument}>
            <ListItemIcon><VisibilityIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{T.view}</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleResend}>
            <ListItemIcon><SendIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{T.btnResend}</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleArchive}>
            <ListItemIcon><ArchiveIcon fontSize="small" /></ListItemIcon>
            <ListItemText>{T.btnArchive}</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </LocalizationProvider>
  );
}

// StatCard component
function StatCard({ label, value, icon, color }) {
  return (
    <StyledCard>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {label}
            </Typography>
            <Typography variant="h4" fontWeight={700}>
              {value}
            </Typography>
          </Box>
          <Avatar sx={{ bgcolor: alpha(color, 0.1), color: color, width: 56, height: 56 }}>
            {icon}
          </Avatar>
        </Stack>
      </CardContent>
    </StyledCard>
  );
}